import PlainDialog from "../src/plain/PlainDialog.js";
export default class ElixDialog extends PlainDialog {}
customElements.define("elix-dialog", ElixDialog);
